// parts
export const GET_PARTS_SUCCESS = 'GET_PARTS_SUCCESS';
export const GET_PARTS_FAILURE = 'GET_PARTS_FAILURE';
export const GET_PARTS_REQUEST = 'GET_PARTS_REQUEST';
export const CLEAR_PARTS = 'CLEAR_PARTS';

// part
export const SELECT_PART = 'SELECT_PART';
export const CLEAR_SELECTED_PART = 'CLEAR_SELECTED_PART';

// pagination
export const SET_PARTS_SEARCH = 'SET_PARTS_SEARCH';
export const SET_PARTS_PAGE_SIZE = 'SET_PARTS_PAGE_SIZE';
export const NEXT_PARTS_PAGE = 'NEXT_PARTS_PAGE';
export const PREV_PARTS_PAGE = 'PREV_PARTS_PAGE';
